import { DialogTag } from '@pixelgenau/ngx-dialog';

export interface M020C090InputDatepickerOverlayDialogData {
    disabledWeekDays?: number[];
    disabledDays?: Date[];
    minDate?: Date;
    maxDate?: Date;
    selected: Date | null;
}

export const M020C090InputDatepickerOverlayDialogTag = new DialogTag<M020C090InputDatepickerOverlayDialogData, Date>(
    'm020-c090-input-datepicker-overlay-dialog',
    async () => {
        const { M020C090InputDatepickerOverlayComponent } =
            await import('./m020-c090-input-datepicker-overlay.component');
        return M020C090InputDatepickerOverlayComponent;
    },
);
